import { defineComponent as _defineComponent } from 'vue'
import { FitIcon } from '@tencent/wphk-ui';
import { ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';
import { ModuleName } from '@/types/module-type';
import { MerchantDpList } from '@/types/merchant';
import HotMerchantSkeleton from '@/components/skeleton/travel-tool-skeleton.vue';
import ThemeClass from '@/components/common/theme/theme-class.vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useConfigStore, useDpStore } from '@/store';
import { i18n } from '@/i18n';
import { ThemeCardType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'hot-merchant',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




const router = useRouter();

// store
const { getConfig } = useConfigStore();
const dpStore = useDpStore();

const isReady = ref(false);

// 热门商户卡片
const hotMerchantDpList = ref<MerchantDpList[]>([]);

// 进入推荐详情
function goToMerchantDetail(contentPosition: string) {
  router.push({ name: 'merchantDetail', query: { id: contentPosition } });
}
// 处理自定义事件
function onClickCustomEvent(key: string) {}

onBeforeMount(async () => {
  const { isMerchantInited, merchantDpList } = dpStore;
  if (!isMerchantInited) {
    const { merchantDpList } = await getConfig(props.moduleName);
    hotMerchantDpList.value = merchantDpList;
  } else {
    hotMerchantDpList.value = merchantDpList;
  }

  isReady.value = true;

  // 没有内容隐藏该模块
  if (!hotMerchantDpList.value.length) {
    emit('onHideModule', ModuleName.HotMerchant);
  }
});

return { __sfc: true,props, emit, router, getConfig, dpStore, isReady, hotMerchantDpList, goToMerchantDetail, onClickCustomEvent, FitIcon, HotMerchantSkeleton, ThemeClass, ThemeCard, i18n, ThemeCardType }
}

})